import {
    GET_ERRORS
} from './type';
import seller from '../Models/seller';

export const sellerChangePassword = (sellerData, history) => dispatch => {
    // let i=[];
    seller.createChangePassword(sellerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                history.push('/seller-dashboard');
            }
            else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }

        })
        .catch(
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: res.data.message
            // })
            // err=>this.setState({errors:err.response.data})
        )
    // return {
    //     type: SELLER_LOGIN,
    //     payload: sellerData,
    // }
};
export const affiliatorChangePassword = (data, history) => dispatch => {
    // let i=[];
    seller.createChangePassword(data)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                alert('パスワードを変更しました')
                window.location.reload();
            }
            else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }

        })
        .catch(
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: res.data.message
            // })
            // err=>this.setState({errors:err.response.data})
        )
    // return {
    //     type: SELLER_LOGIN,
    //     payload: sellerData,
    // }
};